import { ApplicationStatus } from 'modules/teams/domain/enums/application-status';

function getTeamState(users: { state: ApplicationStatus }[]): ApplicationStatus {
  let accepted = false;
  let declined = true;

  for (const { state } of users) {
    if (state === ApplicationStatus.ACCEPTED) {
      accepted = true;
      break;
    }
    if (state !== ApplicationStatus.DECLINED) {
      declined = false;
    }
  }

  return accepted ? ApplicationStatus.ACCEPTED : declined ? ApplicationStatus.DECLINED : ApplicationStatus.PENDING;
}

export default getTeamState;
